import moment from 'moment';
import 'moment/locale/fr';
import { Link } from 'react-router-dom';

/*
 * Styles : mc-guest.css (importé par la page qui liste les réservations).
 */

moment.locale('fr');

const calendarOpts = {
  sameDay: "[Aujourd'hui]",
  nextDay: '[Demain]',
  nextWeek: 'dddd D MMM',
  lastDay: '[Hier]',
  lastWeek: 'dddd D MMM',
  sameElse: 'D MMM YYYY',
};

const STATUS_MAP = {
  pending: { label: 'En attente de confirmation', icon: 'bi-clock-history', tone: 'warn' },
  accepted: { label: 'En attente de paiement', icon: 'bi-credit-card', tone: 'primary' },
  paid: { label: 'Réservation confirmée', icon: 'bi-bag-check-fill', tone: 'ok' },
  completed: { label: 'Voyage terminé', icon: 'bi-flag-fill', tone: 'ok' },
  rejected: { label: 'Réservation annulée', icon: 'bi-x-circle-fill', tone: 'danger' },
  cancelled: { label: 'Annulée', icon: 'bi-slash-circle', tone: 'neutral' },
};

function GuestHistoricVoyageItem({ data }) {
  if (!data) return null;

  const s = STATUS_MAP[data.status] ?? {
    label: data.status,
    icon: 'bi-circle',
    tone: 'neutral',
  };

  const start = moment(data.startDate);
  const end = moment(data.endDate);
  const duration = end.diff(start, 'days');
  const isRejected = data.status === 'rejected';

  return (
    <Link to={'/guest/reservation/' + data.reservationId} className="mc-guest-resa">
      <div className="mc-guest-resa-main">
        {/* Image véhicule */}
        <img
          src={data.Vehicle?.principalPhotos || data.Vehicle?.images?.split(',')[0] || '/char.svg'}
          alt=""
          className="mc-guest-resa-photo"
          loading="lazy"
        />

        {/* Contenu */}
        <div className="mc-guest-resa-body">
          {/* Statut */}
          <span className={`mc-guest-badge mc-guest-badge--${s.tone}`}>
            <i className={`bi ${s.icon}`} aria-hidden="true"></i>
            {s.label}
          </span>

          {/* Dates */}
          <p className={`mc-guest-resa-dates${isRejected ? ' is-struck' : ''}`}>
            <i className="bi bi-calendar3" aria-hidden="true"></i>
            {start.calendar(null, calendarOpts)}
            <span className="arrow">→</span>
            {end.calendar(null, calendarOpts)}
          </p>

          {/* Durée + ID */}
          <p className="mc-guest-resa-meta">
            <i className="bi bi-clock me-1" aria-hidden="true"></i>
            {duration < 1 ? "Moins d'1 jour" : `${duration} jour${duration > 1 ? 's' : ''}`}
            <span className="mx-2">·</span>
            <span className="id">#{data.reservationId}</span>
          </p>

          {/* Message contextuel */}
          {data.status === 'accepted' && (
            <p className="mc-guest-resa-hint">
              <i className="bi bi-credit-card" aria-hidden="true"></i>
              Procédez au paiement pour bloquer les dates.
            </p>
          )}
          {data.status === 'completed' && (
            <p className="mc-guest-resa-hint">
              <i className="bi bi-star" aria-hidden="true"></i>
              Laissez un avis pour améliorer nos services.
            </p>
          )}
          {isRejected && (
            <p className="mc-guest-resa-meta">Annulée {moment(data.updatedAt).fromNow()}</p>
          )}
        </div>

        {/* Flèche de navigation */}
        <i className="bi bi-chevron-right mc-guest-resa-chevron" aria-hidden="true"></i>
      </div>

      {/* CTA paiement — uniquement si "accepted" */}
      {data.status === 'accepted' && (
        <div className="mc-guest-resa-cta">
          <span>
            <i className="bi bi-lightning-fill" aria-hidden="true"></i>
            Action requise — Payer maintenant
          </span>
          <i className="bi bi-arrow-right" aria-hidden="true"></i>
        </div>
      )}
    </Link>
  );
}

export default GuestHistoricVoyageItem;
